<template>
<div class="pseudoheader p-5 mb-2"></div>
<section class="pt-120">
      <div class="about_area">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="about_content pt-120 pb-130">
                <div class="section_title pb">
                  <h4 class="title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">Penandatanganan MoU dan PKS IT Del dan PT Gramedia</h4>
                  <p class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s">Gramedia yaitu semangat literasi, mengembangkan pengetahuan serta mencerdaskan kehidupan bangsa. Era digital semakin berkembang sehingga Smart Library juga perlu dikembangkan dimana orang-orang tidak lagi harus ke perpustakaan untuk mencari buku tetapi bisa mengakses dari mana saja selagi terhubung dengan internet.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="about_image bg_cover wow fadeInLeft" data-wow-duration="1.3s" data-wow-delay="0.2s" style="background-image: url(assets/img/news9.jpg)">
          <div class="image_content">
            <h4 class="experience">7 September 2022</h4>
          </div>
        </div>
      </div>
    </section>
              
    <section class="features_area pt-20 pb-80">
      <div class="container">
        <div class="row justify-content-center">
        </div>
  
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="single_features text-center mt-60 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
              <img src="../../public/assets/img/gramed1.jpg" alt="gramed1" />
              <p>Bapak Arnaldo menyampaikan bahwa perpustakaan memang unit yang sangat penting dalam perkuliahan terkhusus dikarenakan IT Del menerapkan sistem berasrama sehingga mahasiswa lebih banyak menghabiskan waktu di dalam kampus dan salah satu tempat mereka untuk bereksplorasi yaitu perpustakaan, maka dari itu diperlukan penguatan layanan perpustakaan seperti menjalin kerjasama dengan Gramedia.</p>
              
            </div>
          </div>
          <div class="col-lg-4 col-md-6"><div class="single_features text-center mt-60 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.3s">
            <img src="../../public/assets/img/gramed2.jpg" alt="gramed2" />
              
              <p> Kegiatan ini dilanjutkan dengan Launching Smart Library di Perpustakaan IT Del serta pelatihan pemakaian aplikasi tersebut kepada tim di UPT Perpustakaan IT Del. Besar harapannya E-Perpus ini dapat semakin dikembangkan guna mendukung perkuliahan yang ada di IT Del</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single_features text-center mt-60 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s">
              <img src="../../public/assets/img/gramed3.jpg" alt="gramed3" />

              <p>Dalam sambutannya Bapak Matheus mengatakan bahwa tujuan dari Gramedia yaitu semangat literasi, mengembangkan pengetahuan serta mencerdaskan kehidupan bangsa. Era digital semakin berkembang sehingga Smart Library juga perlu dikembangkan dimana orang-orang tidak lagi harus ke perpustakaan untuk mencari buku tetapi bisa mengakses dari mana saja selagi terhubung dengan internet. Beliau sangat berharap kerjasama ini memberikan dampak yang baik dan terbuka untuk peluang kerjasama di bidang lainnya.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>